import { FormQuestionType } from '@televet/shared-types';
import React, { ReactElement } from 'react';
import Prompt, { ElementType } from '../Prompt';
import { IFromDraftCommonProps } from '../Question';
import QuestionHeader from '../QuestionHeader';
import RequiredSelector from './RequiredSelector';

const SignatureInput = ({ index, prompt, isRequired, lastIndex }: IFromDraftCommonProps): ReactElement => {
  return (
    <>
      <QuestionHeader index={index} questionType={FormQuestionType.SignatureInput} lastIndex={lastIndex} />
      <Prompt index={index} prompt={prompt} refType={ElementType.textArea} />
      <RequiredSelector index={index} isRequired={isRequired} />
    </>
  );
};

export default SignatureInput;
